export default __webpack_public_path__ + "static/media/WAPP-Logo.c45adee3.svg";